import { t } from '@/i18n';
import type { FC } from 'react';
import { useParams } from 'react-router';
import { useChangeBrowserTabTitleEffectForPS } from '../hooks';
import { SHEETS_DATA } from '../utils/sheet-data/sheet-data-by-year';
import { Breadcrumb } from './Breadcrumb';
import { Contents } from './Contents';
import { MinistryButtons } from './MinistryButtons';

const breadcrumbs = [
  { title: t('ps-sheets-page-nav-1'), href: '/sheets' },
  {
    title: t('ps-sheets-page-nav-2'),
  },
];

export const SheetsMinistryPage: FC = () => {
  const { year } = useParams();

  const ministries: (typeof SHEETS_DATA)[number]['ministries'] | null =
    SHEETS_DATA.find((data) => data.year === year)?.ministries ?? null;

  useChangeBrowserTabTitleEffectForPS({
    pageKey: 'sheets',
  });

  return (
    <Contents.Frame
      title={t('ps-sheets-menu')}
      breadcrumb={<Breadcrumb items={breadcrumbs} />}
    >
      <Contents.Text
        text={t('ps-sheets-page-text-2')}
        style={{
          width: '100%',
        }}
      />
      {ministries && (
        <MinistryButtons
          buttonsInfo={ministries.map(({ key }) => ({
            ministryKey: key,
            linkProps: {
              to: `/sheets/${year}/${key}`,
            },
          }))}
        />
      )}
    </Contents.Frame>
  );
};
